import React, { useState, useEffect } from 'react'
import './Sections.css'

const SectionHero = ({ scrollY = 0 }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [shouldRender, setShouldRender] = useState(true);
  
  // Determine visibility based on scroll position
  useEffect(() => {
    // Start fading out when scrolled down slightly (e.g., 10% of viewport height)
    const fadeThreshold = window.innerHeight * 0.1;
    const unmountThreshold = window.innerHeight * 0.3; // Unmount when scrolled halfway down
    
    if (scrollY > fadeThreshold) {
      setIsVisible(false);
    } else {
      setIsVisible(true);
    }
    
    // If scrolled past unmount threshold, don't render the component at all
    if (scrollY > unmountThreshold) {
      // Add a small delay before unmounting to allow the slide-out animation to complete
      const timer = setTimeout(() => {
        setShouldRender(false);
      }, 700); // Match this with the CSS transition duration
      
      return () => clearTimeout(timer);
    } else {
      setShouldRender(true);
    }
  }, [scrollY]);
  
  // If we shouldn't render at all, return null
  if (!shouldRender) return null;
  
  return (
    <>
      <section id="hero" className={`headline ${isVisible ? 'visible' : 'hidden'} fade-in`}>
        <div className="hero-content">
            <div className="headline-row">
              <span className="first-part">Building </span>
              <span className="glitch-wrapper">
                <div className="hero glitch">
                  <span className='brands' data-text="brands">brands</span>
                  <span className='realities' data-text="realities">realities</span>
                </div>
              </span>
            </div>
            <div className="headline-row">
              <span className="last-part">that resonate</span>
            </div>
        </div>
      </section>
      <aside className={`${isVisible ? 'visible' : 'hidden'}`}>
        <div className='container'>
          <div className='welcome'>
            <p>Welcome to our creative showcase of groundbreaking projects that use immersive technologies to resonate across dimensions</p>
          </div>
          <div className='scroll'>
            <p><span>SCROLL DOWN</span> <span>TO EXPLORE</span></p><img src="/ui/mouse-scroll-icon.svg" alt="mouse scroll icon" className='mouse-icon' />
          </div>
        </div>
      </aside>
    </>
  )
}

export default SectionHero
